import { Injectable } from "@angular/core";
import { GenericResponse } from "../business-entities/generic-response";
import { WarningLightDataService } from '../data-services/warninglight-data.service';


@Injectable({
    providedIn: 'root'
})

export class WarningLightService {
    Id: number;
    warningLightListRequest =
    {
        searchTerm: '',
        startRecordNumber: 0,
        pageSize: 25,
        sortColumn: '',
        sortDirection: '',
        languageCode: ''
    }
    // 
    constructor(private service: WarningLightDataService)
    {

    }
    

    async getWarningLightList(requestModel: any): Promise<GenericResponse<any>> {
        return this.service.getWarningLightList(requestModel);
    }

    async getWarningLightById(Id: number)  {
        return this.service.getWarningLightById(Id);
    }

    AddUpdateWarningLight(addEditWarningLightModel: any): Promise<GenericResponse<any>> {
        return this.service.AddUpdateWarningLight(addEditWarningLightModel);
    }

    deleteWarningLight(Id: number) {
        return this.service.deleteWarningLight(Id);
    }

    async getWarningLightDropDown(language: string) {
        let warninglightList: any;
        await this.service
            .getWarningLightDropDown(language)
            .then(
                (res: GenericResponse<any>) => {
                    warninglightList = res.responseObject;
                }
            );

        return warninglightList;
    }
}